module.exports = __webpack_public_path__ + "img/abnormalIcon.20d963b4.png";